<template>
  <el-carousel trigger="none" :interval="2500" arrow="always">
    <el-carousel-item v-for="(item,index) in slideInfo" :key="index">
      <img v-bind:src="item.pic_url">
    </el-carousel-item>
  </el-carousel>
</template>
<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
        slideInfo: [
          {
            slide_id: 1,
            add_time: "2019-01-07T11:53:52.000Z",
            pic_url: "http://hten.isdg.cn/slideshow/slide_1.jpg",
            sort: 1,
            to_url: "http://hten.isdg.cn/slideshow/slide_1.jpg",
          },
          {
            slide_id: 2,
            add_time: "2019-01-07T11:54:02.000Z",
            pic_url: "http://hten.isdg.cn/slideshow/slide_2.jpg",
            sort: 2,
            to_url: "http://hten.isdg.cn/slideshow/slide_2.jpg",
          },
          {
            slide_id: 3,
            add_time: "2019-01-07T11:54:14.000Z",
            pic_url: "http://hten.isdg.cn/slideshow/slide_3.jpg",
            sort: 3,
            to_url: "http://hten.isdg.cn/slideshow/slide_3.jpg",
          }
        ]
      }
    },
    mounted(){
    },
    methods: {},
    components: {}
  }
</script>

<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: 0px) and(max-width: 749px) {
    .el-carousel {
      height: 128/$default-w+rem;
      .el-carousel__container {
        height: 128/$default-w+rem;
        width: 100%;
        img {
          width: 100%;
          height: 128/$default-w+rem;
        }
      }
    }
  }

  @media screen and(min-width: 750px) {
    .el-carousel {
      height: 256px;
      .el-carousel__container {
        height: 256px;
        width: 100%;
        img {
          width: 100%;
          height: 256px;
        }
      }
    }
  }

  @media screen and(min-width: 992px) {
    .el-carousel {
      height: 338px;
      .el-carousel__container {
        height: 338px;
        width: 100%;
        img {
          width: 100%;
          height: 338px;
        }
      }
    }
  }

  @media screen and(min-width: 1280px) {
    .el-carousel {
      height: 437px;
      .el-carousel__container {
        height: 437px;
        width: 100%;
        img {
          width: 100%;
          height: 437px;
        }
      }
    }
  }

  @media screen and(min-width: 1440px) {
    .el-carousel {
      height: 492px;
      .el-carousel__container {
        height: 492px;
        width: 100%;
        img {
          width: 100%;
          height: 492px;
        }
      }
    }

  }

  @media screen and(min-width: 1920px) {
    .el-carousel {
      height: 656px;
      .el-carousel__container {
        height: 656px;
        width: 100%;
        img {
          width: 100%;
          height: 656px;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/common/slideshow.vue